const syncNotifications = {
  data: {
    applyFilters: {
      message: 'Aplicando filtros',
      variant: 'info',
    },
  },
};

export default syncNotifications;
